/* eslint-disable max-lines */
/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "@teamprevent/common/healthSurveillance";

import * as questionIds from "./questionIds";

const medicalTypes = [MedicalTypeIds.HAVSFaceToFace];

export const rightGripStrengthAverageQuestion = {
    id: questionIds.RightGripStrengthAverage,
    questionText: "Grip strength, right hand (in kg) Average",
    medicalTypes
};

export const leftGripStrengthAverageQuestion = {
    id: questionIds.LeftGripStrengthAverage,
    questionText: "Grip strength, left hand (in kg) Average",
    medicalTypes
};

/**
 * @deprecated Prefer sections exported from `import { sections } from "../consultation";` which is in a data structure suitable for use with custom medicals
 */
export const havsQuestions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.HavsAssessmentRequired,
        questionText: "Following review of the HAVS questionnaire",
        medicalTypes
    },
    {
        id: questionIds.EverSufferedBlanching,
        questionText: "Have you ever suffered from your fingers going white?",
        medicalTypes
    },
    {
        id: questionIds.BlanchingInResponseToColdDampOrWet,
        questionText: "In response to cold, damp or wet conditions?",
        medicalTypes
    },
    {
        id: questionIds.BlanchingWhileWorking,
        questionText: "While working?",
        medicalTypes
    },
    {
        id: questionIds.BlanchingOtherTimes,
        questionText: "At other times?",
        medicalTypes
    },
    {
        id: questionIds.BlanchingOtherTimesExamples,
        questionText: "Please give examples:",
        medicalTypes
    },
    {
        id: questionIds.BlanchingFirstNoticed,
        questionText: "When did you first notice this whiteness? (Year)",
        medicalTypes
    },
    {
        id: questionIds.BlanchingHowOften,
        questionText: "How often does it occur?",
        medicalTypes
    },
    {
        id: questionIds.BlanchingMostCommonCircumstances,
        questionText: "State most common circumstances",
        medicalTypes
    },
    {
        id: questionIds.ExperienceWhitenessInFeetOrOtherPeriphery,
        questionText: "Do you experience whiteness in your feet or other periphery?",
        medicalTypes
    },
    {
        id: questionIds.ExperienceWhitenessInFeetOrOtherPeripheryWhere,
        questionText: "Please state where whiteness is experienced",
        medicalTypes
    },
    {
        id: questionIds.WhichFingersAffectedByBlanching,
        questionText: "Which fingers are affected? (Click all fingers that have ever gone white)",
        medicalTypes
    },
    {
        id: questionIds.BlanchingWitnessed,
        questionText: "Is the blanching witnessed",
        medicalTypes
    },
    {
        id: questionIds.BlanchingNotWitnessed,
        questionText: "Is the blanching not witnessed",
        medicalTypes
    },
    {
        id: questionIds.Tingling,
        questionText: "Tingling (excluding transient tingling lasting for up to 20 minutes after using vibrating tools)",
        medicalTypes
    },
    {
        id: questionIds.ExperienceTinglingOfFingers,
        questionText: "Do you experience tingling of the fingers?",
        medicalTypes
    },
    {
        id: questionIds.TinglingResponseToCold,
        questionText: "In response to the cold?",
        medicalTypes
    },
    {
        id: questionIds.TinglingWithBlanching,
        questionText: "With blanching?",
        medicalTypes
    },
    {
        id: questionIds.TinglingWhileWorking,
        questionText: "While working?",
        medicalTypes
    },
    {
        id: questionIds.TinglingAtOtherTimes,
        questionText: "At other times?",
        medicalTypes
    },
    {
        id: questionIds.TinglingAtOtherTimesExamples,
        questionText: "Please give examples and how long it lasts:",
        medicalTypes
    },
    {
        id: questionIds.TinglingWhenFirstNoticed,
        questionText: "When did you first notice this? (Year)",
        medicalTypes
    },
    {
        id: questionIds.TinglingWhichFingersAffected,
        questionText: "Which fingers are affected? (Click all fingers that have ever gone white)",
        medicalTypes
    },
    {
        id: questionIds.Numbness,
        questionText: "Numbness (excluding transient tingling lasting for up to 20 minutes after using vibrating tools)",
        medicalTypes
    },
    {
        id: questionIds.DoFingersGoNumb,
        questionText: "Do your fingers go numb?",
        medicalTypes
    },
    {
        id: questionIds.NumbnessResponseToCold,
        questionText: "In response to the cold?",
        medicalTypes
    },
    {
        id: questionIds.NumbnessWithBlanching,
        questionText: "With blanching?",
        medicalTypes
    },
    {
        id: questionIds.NumbnessWhileWorking,
        questionText: "While working?",
        medicalTypes
    },
    {
        id: questionIds.NumbnessOtherTimes,
        questionText: "At other times?",
        medicalTypes
    },
    {
        id: questionIds.NumbnessOtherTimesExamples,
        questionText: "Please give examples and how long it lasts:",
        medicalTypes
    },
    {
        id: questionIds.NumbnessFirstNotice,
        questionText: "When did you first notice this? (Year)",
        medicalTypes
    },
    {
        id: questionIds.NumbnessWhichFingers,
        questionText: "Which fingers are affected? (Click all fingers that have ever gone numb)",
        medicalTypes
    },
    {
        id: questionIds.NumbnessDifficultyHandlingSmallObjects,
        questionText: "Do you have any difficulty handling or manipulating small objects?",
        medicalTypes
    },
    {
        id: questionIds.NumbnessDifficultyHandlingSmallObjectsWhen,
        questionText: "When does this occur",
        medicalTypes
    },
    {
        id: questionIds.AnyBlanchingTinglingNumbnessAffectWorkOrLeisure,
        questionText: "Do any of these symptoms (blanching, tingling or numbness) affect your work or leisure activities?",
        medicalTypes
    },
    {
        id: questionIds.AnyBlanchingTinglingNumbnessAffectWorkOrLeisureFurtherDetails,
        questionText: "Please give details",
        medicalTypes
    },
    {
        id: questionIds.ProblemsWithMusclesOrJoints,
        questionText: "Are you experiencing problems with the muscles or joints of your hands/arms/wrists/elbows/shoulders?",
        medicalTypes
    },
    {
        id: questionIds.ProblemsWithMusclesOrJointsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.Pain,
        questionText: "Pain",
        medicalTypes
    },
    {
        id: questionIds.PainFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.Stiffness,
        questionText: "Stiffness",
        medicalTypes
    },
    {
        id: questionIds.StiffnessFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.Swelling,
        questionText: "Swelling",
        medicalTypes
    },
    {
        id: questionIds.SwellingFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.Weakness,
        questionText: "Weakness",
        medicalTypes
    },
    {
        id: questionIds.WeaknessFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.DominantHand,
        questionText: "Dominant hand",
        medicalTypes
    },
    {
        id: questionIds.LeadingHand,
        questionText: "Leading hand",
        medicalTypes
    },
    {
        id: questionIds.FirstStartUsingVibrating,
        questionText: "When did you first start using vibrating tools or equipment?",
        medicalTypes
    },
    {
        id: questionIds.WhereNoticeVibrationMost,
        questionText: "Where do you notice the vibration most?",
        medicalTypes
    },
    {
        id: questionIds.WhenStopUsingVibratingTools,
        questionText: "If you no longer use vibrating tools when did you stop?",
        medicalTypes
    },
    {
        id: questionIds.MainElementsJobInvolvingVibratingTools,
        questionText: "Which of the main elements of your present job involve use of vibrating tools or equipment and how much time per day (‘trigger’ or contact time)? Include the Hours/Day and Days/Week in the description",
        medicalTypes
    },
    {
        id: questionIds.WhenJoinCompany,
        questionText: "When did you join the company?",
        medicalTypes
    },
    {
        id: questionIds.MainJobsAndDepartments,
        questionText: "List main jobs and departments in order (include the Hours/Day and Days/Week):",
        medicalTypes
    },
    {
        id: questionIds.PreviousJobsInvolvingVibrations,
        questionText: "What jobs did you do previously, outside this company, involving vibration? Include the Hours/Day and Days/Week in the description",
        medicalTypes
    },
    {
        id: questionIds.ExposureToChemicalsAtWork,
        questionText: "Have you had any exposure to chemicals at work?",
        medicalTypes
    },
    {
        id: questionIds.ExposureToChemicalsAtWorkFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.HandArmVibrationHobbies,
        questionText: "Do any of your hobbies expose you to hand-arm vibration?",
        medicalTypes
    },
    {
        id: questionIds.HandArmVibrationHobbiesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.DoYouSmoke,
        questionText: "Do you smoke?",
        medicalTypes
    },
    {
        id: questionIds.HowManySmokePerDay,
        questionText: "How many do you smoke each day?",
        medicalTypes
    },
    {
        id: questionIds.ExSmoker,
        questionText: "Are you an ex-smoker?",
        medicalTypes
    },
    {
        id: questionIds.ExSmokerWhenQuit,
        questionText: "Please state when you quit",
        medicalTypes
    },
    {
        id: questionIds.DrinkAlcohol,
        questionText: "Do you drink alcohol?",
        medicalTypes
    },
    {
        id: questionIds.DrinkAlcoholNumberOfUnitsPerWeek,
        questionText: "Please state approx. units consumed per week",
        medicalTypes
    },
    {
        id: questionIds.CloseFamilyVibrationWhiteFinger,
        questionText: "Do other members of your family suffer from white finger? (brothers, sisters and parents only)",
        medicalTypes
    },
    {
        id: questionIds.CloseFamilyVibrationWhiteFingerWho,
        questionText: "Who?",
        medicalTypes
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperation,
        questionText: "Have you ever had a neck/arm/hand injury?",
        medicalTypes
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperationWhatWhen,
        questionText: "What and when?",
        medicalTypes
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperationAnyProblems,
        questionText: "Were you left with any problems?",
        medicalTypes
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperationAnyProblemsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseJoints,
        questionText: "Joints?",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseJointsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseSkin,
        questionText: "Skin?",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseSkinFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseNerves,
        questionText: "Nerves?",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseNervesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseHeartBloodVessels,
        questionText: "Heart or Blood vessels?",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseHeartBloodVesselsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseOther,
        questionText: "Other?",
        medicalTypes
    },
    {
        id: questionIds.SeriousDiseaseOtherFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.AnyLongTermMedicationTreatmentForCondition,
        questionText: "Are you on any long-term medication or treatment for any condition:",
        medicalTypes
    },
    {
        id: questionIds.AnyLongTermMedicationTreatmentForConditionFurtherDetails,
        questionText: "Please provide details",
        medicalTypes
    },
    {
        id: questionIds.LastExposureToVibration,
        questionText: "Note last exposure to vibration",
        medicalTypes
    },
    {
        id: questionIds.RoomTemperature,
        questionText: "Room temperature (ºC)",
        medicalTypes
    },
    {
        id: questionIds.ExaminationUnableToCarryOut,
        questionText: "Unable to carry out medical",
        medicalTypes
    },
    {
        id: questionIds.ExaminationUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
        medicalTypes
    },
    {
        id: questionIds.AppearanceOfHands,
        questionText: "Appearance of hands – note any signs of vascular disease, deformity, scars, callosities or muscle wasting.",
        medicalTypes
    },
    {
        id: questionIds.RightPulseRate,
        questionText: "Pulse rate (bpm) (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftPulseRate,
        questionText: "Pulse rate (bpm) (Left)",
        medicalTypes
    },
    {
        id: questionIds.RightBloodPressure,
        questionText: "Blood pressure (mm Hg) Lying/Sitting (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftBloodPressure,
        questionText: "Blood pressure (mm Hg) Lying/Sitting (Left)",
        medicalTypes
    },
    {
        id: questionIds.RightPositiveRadialPulse,
        questionText: "Positive Radial pulse (Right)",
        medicalTypes
    },
    {
        id: questionIds.RightAbsentRadialPulse,
        questionText: "Absent Radial pulse (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftPositiveRadialPulse,
        questionText: "Positive Radial pulse (Left)",
        medicalTypes
    },
    {
        id: questionIds.LeftAbsentRadialPulse,
        questionText: "Absent Radial pulse (Left)",
        medicalTypes
    },
    {
        id: questionIds.RightPositiveUlnarPulse,
        questionText: "Positive Ulnar pulse (Right)",
        medicalTypes
    },
    {
        id: questionIds.RightAbsentUlnarPulse,
        questionText: "Absent Ulnar pulse (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftPositiveUlnarPulse,
        questionText: "Positive Ulnar pulse (Left)",
        medicalTypes
    },
    {
        id: questionIds.LeftAbsentUlnarPulse,
        questionText: "Absent Ulnar pulse (Left)",
        medicalTypes
    },
    {
        id: questionIds.RightPositiveAllensTest,
        questionText: "Positive Allen's test (Right)",
        medicalTypes
    },
    {
        id: questionIds.RightNegativeAllensTest,
        questionText: "Negative Allen's test (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftPositiveAllensTest,
        questionText: "Positive Allen's test (Left)",
        medicalTypes
    },
    {
        id: questionIds.LeftNegativeAllensTest,
        questionText: "Negative Allen's test (Left)",
        medicalTypes
    },
    {
        id: questionIds.RightNormalSemmesWeinstein,
        questionText: "Normal Semmes-Weinstein (Right)",
        medicalTypes
    },
    {
        id: questionIds.RightAbnormalSemmesWeinstein,
        questionText: "Abnormal Semmes-Weinstein (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftNormalSemmesWeinstein,
        questionText: "Normal Semmes-Weinstein (Left)",
        medicalTypes
    },
    {
        id: questionIds.LeftAbnormalSemmesWeinstein,
        questionText: "Abnormal Semmes-Weinstein (Left)",
        medicalTypes
    },
    {
        id: questionIds.RightNormalPurduePegboardTest,
        questionText: "Normal Manual dexterity (Purdue Pegboard test) (Right)",
        medicalTypes
    },
    {
        id: questionIds.RightAbnormalPurduePegboardTest,
        questionText: "Abnormal Manual dexterity (Purdue Pegboard test) (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftNormalPurduePegboardTest,
        questionText: "Normal Manual dexterity (Purdue Pegboard test) (Left)",
        medicalTypes
    },
    {
        id: questionIds.LeftAbnormalPurduePegboardTest,
        questionText: "Abnormal Manual dexterity (Purdue Pegboard test) (Left)",
        medicalTypes
    },
    {
        id: questionIds.RightNormalAdsonsTest,
        questionText: "Normal Adson's test (Right)",
        medicalTypes
    },
    {
        id: questionIds.RightAbnormalAdsonsTest,
        questionText: "Abnormal Adson's test (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftNormalAdsonsTest,
        questionText: "Normal Adson's test (Left)",
        medicalTypes
    },
    {
        id: questionIds.LeftAbnormalAdsonsTest,
        questionText: "Abnormal Adson's test (Left)",
        medicalTypes
    },
    {
        id: questionIds.RightNormalTinelsTest,
        questionText: "Normal Tinel's test (Right)",
        medicalTypes
    },
    {
        id: questionIds.RightAbnormalTinelsTest,
        questionText: "Abnormal Tinel's test (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftNormalTinelsTest,
        questionText: "Normal Tinel's test (Left)",
        medicalTypes
    },
    {
        id: questionIds.LeftAbnormalTinelsTest,
        questionText: "Abnormal Tinel's test (Left)",
        medicalTypes
    },
    {
        id: questionIds.RightNormalPhalensTest,
        questionText: "Normal Phalen's test (Right)",
        medicalTypes
    },
    {
        id: questionIds.RightAbnormalPhalensTest,
        questionText: "Abnormal Phalen's test (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftNormalPhalensTest,
        questionText: "Normal Phalen's test (Left)",
        medicalTypes
    },
    {
        id: questionIds.LeftAbnormalPhalensTest,
        questionText: "Abnormal Phalen's test (Left)",
        medicalTypes
    },
    {
        id: questionIds.AbnormalityOfNecksOrUpperLimbs,
        questionText: "Describe any abnormality of neck or upper limbs",
        medicalTypes
    },
    {
        id: questionIds.RightGripStrength1,
        questionText: "Grip strength, right hand (in kg) Measurement 1",
        medicalTypes
    },
    {
        id: questionIds.RightGripStrength2,
        questionText: "Grip strength, right hand (in kg) Measurement 2",
        medicalTypes
    },
    {
        id: questionIds.RightGripStrength3,
        questionText: "Grip strength, right hand (in kg) Measurement 3",
        medicalTypes
    },
    rightGripStrengthAverageQuestion,
    {
        id: questionIds.LeftGripStrength1,
        questionText: "Grip strength, left hand (in kg) Measurement 1",
        medicalTypes
    },
    {
        id: questionIds.LeftGripStrength2,
        questionText: "Grip strength, left hand (in kg) Measurement 2",
        medicalTypes
    },
    {
        id: questionIds.LeftGripStrength3,
        questionText: "Grip strength, left hand (in kg) Measurement 3",
        medicalTypes
    },
    leftGripStrengthAverageQuestion,
    {
        id: questionIds.PrimaryRaynaudsPhenomenonPresent,
        questionText: "Primary Raynaud’s phenomenon present? ",
        medicalTypes
    },
    {
        id: questionIds.SecondaryRaynaudsPhenomenonPresent,
        questionText: "Secondary Raynaud’s phenomenon present?",
        medicalTypes
    },
    {
        id: questionIds.RaynaudsPhenomenonPresentVibrationInduced,
        questionText: "Is the vibration induced?",
        medicalTypes
    },
    {
        id: questionIds.RightStockholmVascularGrading,
        questionText: "Stockholm Vascular grading (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftStockholmVascularGrading,
        questionText: "Stockholm Vascular grading (Left)",
        medicalTypes
    },
    {
        id: questionIds.NeurologicalImpairmentSuggested,
        questionText: "Neurological impairment suggested by clinical assessment?",
        medicalTypes
    },
    {
        id: questionIds.CarpalTunnelSyndromeSuggested,
        questionText: "Is carpal tunnel syndrome suggested by history and findings?",
        medicalTypes
    },
    {
        id: questionIds.RightStockholmSensorineuralGrading,
        questionText: "Stockholm Sensorineural grading (Right)",
        medicalTypes
    },
    {
        id: questionIds.LeftStockholmSensorineuralGrading,
        questionText: "Stockholm Sensorineural grading (Left)",
        medicalTypes
    },
    {
        id: questionIds.MuscularSoftTissueDisorderPresent,
        questionText: "Muscular or soft tissue disorder present?",
        medicalTypes
    },
    {
        id: questionIds.EvidenceSkeletalDisorder,
        questionText: "Evidence of skeletal disorder?",
        medicalTypes
    },
    {
        id: questionIds.VascularLatentPeriods,
        questionText: "Vascular Latent periods (in years)",
        medicalTypes
    },
    {
        id: questionIds.NeurologicalLatentPeriods,
        questionText: "Neurological Latent periods (in years)",
        medicalTypes
    },
    {
        id: questionIds.MusculoskeletalLatentPeriods,
        questionText: "Musculoskeletal Latent periods (in years)",
        medicalTypes
    },
    {
        id: questionIds.VibrotactileThresholdFurtherInvestigationsRequired,
        questionText: "Vibrotactile Threshold - Further special investigations required?",
        medicalTypes
    },
    {
        id: questionIds.TemperatureThresholdFurtherInvestigationsRequired,
        questionText: "Temperature Threshold - Further special investigations required?",
        medicalTypes
    },
    {
        id: questionIds.HavsTier,
        questionText: "What tier are you undertaking?",
        medicalTypes
    },
    {
        id: questionIds.ClinicalAssessmentOfHavsSignsAndSymptomReview,
        questionText: "Clinical Assessment: Please indicate if a 3-yearly assessment for a HAVS signs and symptom review with a qualified person has been undertaken",
        medicalTypes
    },
    {
        id: questionIds.TierOneOutcome,
        questionText: "Outcome",
        medicalTypes
    },
    {
        id: questionIds.AdditionalAdviceAndRecallPlan,
        questionText: "Additional Advice and Recall Plan",
        medicalTypes
    },
    {
        id: questionIds.TierTwoOutcome,
        questionText: "Outcome",
        medicalTypes
    },
    {
        id: questionIds.BlanchingWitnessedByPersonCompletingScreening,
        questionText: "Is the blanching witnessed by the person completing the screening?",
        medicalTypes
    },
    {
        id: questionIds.PreviousJobsInvolvingVibrationsUpdated,
        questionText: "What jobs did you do previously, outside this company, involving vibration? Include the Hours/Day and Days/Week/Years in the description",
        medicalTypes
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperationUpdated,
        questionText: "Have you ever had a neck/arm/hand injury or operation?",
        medicalTypes
    },
    {
        id: questionIds.RadialPulseRight,
        questionText: "Right",
        medicalTypes
    },
    {
        id: questionIds.RadialPulseLeft,
        questionText: "Left",
        medicalTypes
    },
    {
        id: questionIds.UlnarPulseRight,
        questionText: "Right",
        medicalTypes
    },
    {
        id: questionIds.UlnarPulseLeft,
        questionText: "Left",
        medicalTypes
    },
    {
        id: questionIds.AllensTestRight,
        questionText: "Right",
        medicalTypes
    },
    {
        id: questionIds.AllensTestLeft,
        questionText: "Left",
        medicalTypes
    },
    {
        id: questionIds.SemmesWeinsteinRight,
        questionText: "Right",
        medicalTypes
    },
    {
        id: questionIds.SemmesWeinsteinRightScore,
        questionText: "Score",
        medicalTypes
    },
    {
        id: questionIds.SemmesWeinsteinLeft,
        questionText: "Left",
        medicalTypes
    },
    {
        id: questionIds.SemmesWeinsteinLeftScore,
        questionText: "Score",
        medicalTypes
    },
    {
        id: questionIds.ManualDexterityRight,
        questionText: "Right",
        medicalTypes
    },
    {
        id: questionIds.ManualDexterityRightScore,
        questionText: "Score",
        medicalTypes
    },
    {
        id: questionIds.ManualDexterityLeft,
        questionText: "Left",
        medicalTypes
    },
    {
        id: questionIds.ManualDexterityLeftScore,
        questionText: "Score",
        medicalTypes
    },
    {
        id: questionIds.ManualDexterityBothScore,
        questionText: "Score",
        medicalTypes
    },
    {
        id: questionIds.AdsonsTestRight,
        questionText: "Right",
        medicalTypes
    },
    {
        id: questionIds.AdsonsTestLeft,
        questionText: "Left",
        medicalTypes
    },
    {
        id: questionIds.TinelsTestRight,
        questionText: "Right",
        medicalTypes
    },
    {
        id: questionIds.TinelsTestLeft,
        questionText: "Left",
        medicalTypes
    },
    {
        id: questionIds.PhelansTestRight,
        questionText: "Right",
        medicalTypes
    },
    {
        id: questionIds.PhelansTestLeft,
        questionText: "Left",
        medicalTypes
    },
    {
        id: questionIds.AdvisoryLeafletReceivedByEmployee,
        questionText: "Has advisory leaflet been received by employee?",
        medicalTypes
    },
    {
        id: questionIds.AdditionalClinicalNotes,
        questionText: "Additional Clinical Notes",
        medicalTypes
    },
    {
        id: questionIds.TinglingWhichFingersAffectedUpdated,
        questionText: "Which fingers are affected? (Click all fingers that have ever had tingling)",
        medicalTypes
    }
];
/* eslint-enable max-len */
